import { IcAirport } from '@assets/icons/24x24';
import { Icon, IconButton, Text } from '@chakra-ui/react';
import { usePlatformsPanelContext } from '@components/cockpit/Cockpit';
import { useAppSelector } from '@hooks/redux.hooks';
import { selectAllActiveNotProcessedNotificationsCount } from '@redux/data/data.selectors';

export default function PlatformsButton() {
  const { setIsPlatformsPanelOpen } = usePlatformsPanelContext();
  const notProcessedNotificationCount = useAppSelector(selectAllActiveNotProcessedNotificationsCount);

  return (
    <IconButton height="56px" width="fit-content" variant="cockpitHeader" onClick={() => setIsPlatformsPanelOpen(true)}>
      <Icon as={IcAirport} boxSize="24px" color="neutral.300" _groupHover={{ color: 'skyBlue' }} />
      {notProcessedNotificationCount !== 0 && (
        <Text
          paddingX={0.25}
          textStyle="xs"
          fontWeight="medium"
          backgroundColor="red"
          color="neutral.white"
          height="16px"
          minWidth="20px"
          textAlign="center"
        >
          {notProcessedNotificationCount}
        </Text>
      )}
    </IconButton>
  );
}
